var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowFillLeftIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 16,
    viewBox: "0 0 9 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.6705 15.1704C8.23116 15.6098 7.51884 15.6098 7.07951 15.1704L0.704554 8.79549C0.265204 8.35616 0.265204 7.64384 0.704554 7.2045L7.07951 0.829501C7.51884 0.390166 8.23116 0.390166 8.6705 0.829501C9.10983 1.26884 9.10983 1.98116 8.6705 2.42049L3.09099 8L8.6705 13.5795C9.10983 14.0189 9.10983 14.7311 8.6705 15.1704Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowFillLeftIcon);
export default __webpack_public_path__ + "static/media/arrow-fill-left-icon.efd3acf2e4e0649eefa0b35151b56db4.svg";
export { ForwardRef as ReactComponent };